import { Validate } from '@edgvr-front/util/validate';
import { CompanyName } from '../interface';
import { companyName } from '../schema';

export class CompanyStudentDevicesListVO {
  private static configValidation = Validate.compile(
    CompanyStudentDevicesListVO.configValidationSchema()
  );

  constructor(readonly value: CompanyStudentDevicesList) {
    Validate.assert(CompanyStudentDevicesListVO.configValidation, this.value);
  }

  private static configValidationSchema() {
    return {
      type: 'object',
      required: ['companyName'],
      properties: {
        companyName,
      },
      additionalProperties: false,
    };
  }
}

interface CompanyStudentDevicesList {
  companyName: CompanyName;
}
